
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  corporateConfig = {
    auraSetting: {
      displayAmount: "",
    },
  };
  url = "/api/corp/config/get";
  page = 1;
  value = "";

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.corporateConfig = await doGet(this.url);
      // console.log(this.corporateConfig);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      await doPost("/api/corp/config/other/save", this.corporateConfig);

      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
